import { useLogUserActivity } from '../../api/endpoints/users/users';
import { UserActivityType } from '../../api/models/userActivityType';
import { useAuthStore } from '../../auth/store';

export const useActivity = () => {
  const { mutate: logUserActivityMutation } = useLogUserActivity();
  const impersonatedBy = useAuthStore((state) => state.impersonatedBy);

  const logSelectModule = async ({ moduleId, courseId }) => {
    if (impersonatedBy) return;
    const activity = {
      activity: UserActivityType.open_module,
      moduleId,
      courseId,
    };

    await logUserActivityMutation({
      userId: 'me',
      data: activity,
    });
  };

  const logSelectTask = async ({ moduleId, courseId, taskId }) => {
    if (impersonatedBy) return;
    const activity = {
      activity: UserActivityType.open_task,
      moduleId,
      courseId,
      taskId,
    };

    await logUserActivityMutation({
      userId: 'me',
      data: activity,
    });
  };

  const logCloseTask = async ({ moduleId, courseId, taskId }) => {
    if (impersonatedBy) return;
    const activity = {
      activity: UserActivityType.close_task,
      moduleId,
      courseId,
      taskId,
    };

    await logUserActivityMutation({
      userId: 'me',
      data: activity,
    });
  };

  const logSubmitModule = async ({ moduleId, courseId }) => {
    if (impersonatedBy) return;
    const activity = {
      activity: UserActivityType.submit_module,
      moduleId,
      courseId,
    };

    await logUserActivityMutation({
      userId: 'me',
      data: activity,
    });
  };

  return {
    logSelectModule,
    logSelectTask,
    logCloseTask,
    logSubmitModule,
  };
};

export default useActivity;
